/* DACKO course week: under a workshop start date (Mondays only, snippets/dacko-course-start-date
   .liquid), names the Monday to Friday the course runs once a Monday is picked, because the
   browser's own calendar cannot highlight a week (Casey 2026-10-17). The input's
   data-course-week names its line. The line is aria-live: it is shown first and filled on the
   next frame, because a live region shown and filled at once can go unannounced. A date that is
   not a Monday (Firefox and phone pickers allow one) or an empty field hides it.
   Re-inits on shopify:section:load for the Theme Editor. */
(() => {
  const lang = document.documentElement.lang || 'en';
  const format = (date, withYear) =>
    date.toLocaleDateString(lang, { weekday: 'short', month: 'short', day: 'numeric', ...(withYear && { year: 'numeric' }) });

  function initField(input) {
    if (input.dataset.dackoCourseWeekInit) return; // guard against double-binding
    const line = document.getElementById(input.dataset.courseWeek);
    const text = line && line.querySelector('[data-course-week-text]');
    if (!text) return;
    input.dataset.dackoCourseWeekInit = '1';

    const update = () => {
      // Noon, so no time zone moves the date to the day before
      const start = input.value ? new Date(`${input.value}T12:00:00`) : null;
      if (!start || Number.isNaN(start.getTime()) || start.getDay() !== 1) {
        line.hidden = true;
        text.textContent = '';
        return;
      }
      const end = new Date(start);
      end.setDate(start.getDate() + 4);
      const crossesYear = start.getFullYear() !== end.getFullYear();
      const words = line.dataset.template.replace('__START__', format(start, crossesYear)).replace('__END__', format(end, true));
      line.hidden = false;
      requestAnimationFrame(() => {
        text.textContent = words;
      });
    };

    input.addEventListener('input', update);
    input.addEventListener('change', update);
    update();
  }

  const initAll = (scope) => (scope || document).querySelectorAll('input[data-course-week]').forEach(initField);

  initAll(); // `defer` guarantees the DOM is parsed
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
